"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var PREFIX = 'https://bob.io/wp-content/uploads/';
var LOADING_IMG = 'loading.gif';
var LOADING_IBERIA_IMG = 'loadingIberia.gif';

var Loading = function Loading(_ref) {
  var active = _ref.active,
      iberia = _ref.iberia;
  return _react["default"].createElement(_style.Container, {
    active: active
  }, _react["default"].createElement("img", {
    src: "".concat(PREFIX).concat(!iberia ? LOADING_IMG : LOADING_IBERIA_IMG),
    alt: "Loading"
  }));
};

Loading.propTypes = {
  active: _propTypes["default"].bool,
  iberia: _propTypes["default"].bool
};
Loading.defaultProps = {
  active: false,
  iberia: false
};
var _default = Loading;
exports["default"] = _default;